import React, { useEffect, useState, Fragment } from 'react';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import { Search } from '@material-ui/icons';
import { Checkbox, InputAdornment, TextField } from '@material-ui/core';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Button from 'components/CustomButtons/Button.js';

import { WithApp } from 'contexts/appContext';
import { useGroupedCheckbox } from 'hooks/useGroupedCheckbox';

const useStyles = makeStyles((props) => {
  /* console.log(props); */
  return {
    containerDataGeneral: {
      border: '3px solid #e2e2e5',
      borderRadius: '5px'
    },
    search: {
      width: '97%',
      margin: 'auto',
      marginTop: '15px',
      display: 'flex'
    },
    containerPermissions: {
      overflowY: 'auto',
      maxHeight: '57Vh',
      padding: '6px',
      '&::-webkit-scrollbar-track': {
        borderRadius: '10px'
      },
      '&::-webkit-scrollbar': {
        width: '7px',
        backgroundColor: '#f1f1f1'
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#d5d5d9',
        borderRadius: '10px'
      },
      '&::-webkit-scrollbar:horizontal': {
        display: 'none'
      }
    },
    nested: {
      paddingLeft: '32px'
    },
    listParent: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      height: '42px'
    }
  };
});

export default WithApp(function ListGrouped(props) {
  const { data, getCheckbox, buttonText, buttonColor, getPermissionCheckeds } = props;
  const [filteredData, setFilteredData] = useState(data);

  const classes = useStyles({ height: '14Vh' });

  const [parentTotggles, setParentToggles] = useState([]);

  const {
    grandChecked,
    toggleChildCheckbox,
    toggleParentCheckbox,
    toggleGrandParentCheckbox,
    getCheckeds
  } = useGroupedCheckbox({
    dataArray: filteredData,
    setDataArray: setFilteredData,
    callback: getPermissionCheckeds
  });

  const handleToggle = (id) => {
    let arrIdToggles = parentTotggles;
    if (arrIdToggles.includes(id)) {
      for (var i = 0; i < arrIdToggles.length; i++) {
        if (arrIdToggles[i] === id) {
          arrIdToggles.splice(i, 1);
        }
      }
      setParentToggles([...arrIdToggles]);
    } else {
      setParentToggles([...arrIdToggles, id]);
    }
  };

  function filter(e) {
    let search = e.target.value;
    if (search.length === 0) {
      setFilteredData(data);
    } else {
      setFilteredData(
        data.filter((item) => {
          return item.description.toLowerCase().includes(search.toLowerCase());
        })
      );
    }
  }

  useEffect(() => {
    setFilteredData([...data]);
  }, [data]);

  return (
    <>
      <div className={classes.containerDataGeneral}>
        <div className={classes.search}>
          <Checkbox
            checked={!!grandChecked.checked}
            indeterminate={!!grandChecked.indeterminate}
            onClick={toggleGrandParentCheckbox}
            inputProps={{ 'aria-label': 'primary checkbox' }}
          />
          <TextField
            className={classes.margin}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              )
            }}
            onChange={filter}
            fullWidth
          />
        </div>
        <div className={classes.containerPermissions}>
          <List component="div">
            {filteredData.map((parentPerm, parentIndex) => {
              const labelId = `checkbox-list-label-${parentPerm.id}`;
              return (
                <Fragment key={parentPerm.id}>
                  <ListItem button dense>
                    <ListItemIcon>
                      <Checkbox
                        edge="start"
                        disableRipple
                        checked={!!parentPerm.checked}
                        onClick={() => toggleParentCheckbox(parentIndex)}
                        tabIndex={-1}
                        indeterminate={!!parentPerm.indeterminate}
                      />
                    </ListItemIcon>
                    <span
                      onClick={() => handleToggle(parentPerm.id)}
                      className={classes.listParent}
                    >
                      <ListItemText id={labelId} primary={parentPerm.description} />
                      {parentTotggles.includes(parentPerm.id) ? <ExpandLess /> : <ExpandMore />}
                    </span>
                  </ListItem>

                  <Collapse
                    in={parentTotggles.includes(parentPerm.id)}
                    timeout="auto"
                    unmountOnExit
                  >
                    <List component="div" disablePadding>
                      {parentPerm?.permissions.map((child, childIndex) => {
                        return (
                          <ListItem
                            key={child.id}
                            button
                            className={classes.nested}
                            dense
                            onClick={() => toggleChildCheckbox(parentIndex, childIndex)}
                          >
                            <ListItemIcon>
                              <input
                                type="checkbox"
                                checked={!!child.checked}
                                onChange={(e) => {}}
                              />
                            </ListItemIcon>
                            <ListItemText primary={child.description} />
                          </ListItem>
                        );
                      })}
                    </List>
                  </Collapse>
                </Fragment>
              );
            })}
          </List>
        </div>
      </div>
      {props.buttonHide ? undefined : (
        <div style={{ float: 'right', marginTop: '10px' }}>
          <Button
            id="btnGetChecks"
            color={
              buttonColor === 'warn'
                ? props.themeContext.buttonColorWarning
                : buttonColor === 'danger'
                ? props.themeContext.buttonColorDanger
                : props.themeContext.buttonColor
            }
            size="sm"
            onClick={() => {
              getCheckbox(getCheckeds());
            }}
            disabled={data.length < 1}
          >
            {buttonText}
          </Button>
        </div>
      )}
    </>
  );
});
